import { motion } from "framer-motion";
import { Leaf } from "lucide-react";

const AnnouncementBar = () => {
  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 h-10 bg-brand-deepGreen flex items-center justify-center"
      data-testid="announcement-bar"
    >
      <div className="flex items-center gap-2 text-brand-softBeige">
        <span className="text-xs tracking-[0.15em] uppercase font-body font-light">
          Nourish your roots naturally
        </span>
        <Leaf className="w-3.5 h-3.5 text-brand-warmGold" strokeWidth={1.5} />
        <span className="text-xs tracking-[0.15em] uppercase font-body font-light">
          Tropical hair care made with intention
        </span>
      </div>
    </motion.div>
  );
};

export default AnnouncementBar;
